import { Component, Input, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { __awaiter } from 'tslib';
import { LoggingService, CountryService, CountryQuery, FGBTranslationLoader, FGBMissingTranslationHandler } from '@fgb/core';
import { TranslateModule, TranslateLoader, MissingTranslationHandler } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@fgb/core';
import * as ɵngcc2 from '@angular/forms';
import * as ɵngcc3 from '@angular/common';
import * as ɵngcc4 from '@ngx-translate/core';

function CountryAndRegionsComponent_option_10_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "option", 11);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const country_r5 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("value", country_r5.CountryName);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", country_r5.DisplayName, " ");
} }
function CountryAndRegionsComponent_select_18_option_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "option", 11);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const region_r7 = ctx.$implicit;
    ɵngcc0.ɵɵpropertyInterpolate("value", region_r7.RegionName);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", region_r7.DisplayName, " ");
} }
const _c0 = function (a0) { return { "is-invalid": a0 }; };
function CountryAndRegionsComponent_select_18_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "select", 12);
    ɵngcc0.ɵɵelementStart(1, "option", 5);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵpipe(3, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(4, CountryAndRegionsComponent_select_18_option_4_Template, 2, 2, "option", 6);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(5, _c0, ctx_r1.HasSubmitted && !!ctx_r1.Form.controls.County.errors));
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(3, 3, "region.options.default.select"));
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r1.regionOptions);
} }
function CountryAndRegionsComponent_input_19_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "input", 12);
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(1, _c0, ctx_r2.HasSubmitted && !!ctx_r2.Form.controls.County.errors));
} }
function CountryAndRegionsComponent_div_20_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 7);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵpipe(2, "translate");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(2, 1, "address.missing.region.select"));
} }
function CountryAndRegionsComponent_div_21_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 7);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵpipe(2, "translate");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(2, 1, "address.missing.region.entry"));
} }
const _c1 = function (a0, a1) { return { "form-group col-lg-6 mb-3 mb-lg-0": a0, "form-group col-lg-12": a1 }; };
const _c2 = function (a0, a1) { return { "form-group col-lg-6": a0, "form-group col-lg-12": a1 }; };
class CountryAndRegionsComponent {
    constructor(logService, countryService, countryQuery) {
        this.logService = logService;
        this.countryService = countryService;
        this.countryQuery = countryQuery;
        this.HasSubmitted = false;
        this.SeparateRow = false;
        this.regionOptions = [];
    }
    ngOnInit() {
        this.retrieveCountries();
    }
    retrieveCountries() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.countryService.fetchCountries().toPromise();
            this.countryOptions = this.countryQuery.getAll().sort((a, b) => {
                if (a.Ordinal < b.Ordinal) {
                    return -1;
                }
                else if (a.Ordinal === b.Ordinal) {
                    return a.DisplayName.localeCompare(b.DisplayName);
                }
                return 0;
            });
            if (this.Form) {
                if (this.Form.get('Country')) {
                    this.selectedCountry = this.Form.get('Country').value;
                    this.selectedCounty = this.Form.get('County').value;
                    this.getRegionsByCountry(this.Form.get('Country').value);
                }
            }
        });
    }
    getRegionsByCountry(CountryName) {
        let foundCountry = this.countryOptions.find((c) => c.CountryName === CountryName);
        if (foundCountry) {
            this.getRegions(foundCountry);
            if (this.selectedCountry !== null) {
                if (this.selectedCountry === foundCountry.DisplayName) {
                    this.Form.controls.County.setValue(this.selectedCounty);
                }
                else {
                    this.Form.controls.County.setValue('');
                }
            }
            else {
                this.Form.controls.County.setValue('');
            }
        }
        else {
            this.Form.controls.Country.setValue('');
            this.logService.warning('No country data was found for that country');
        }
    }
    getRegions(country) {
        if (country.Regions) {
            this.regionOptions = [];
        }
        this.regionOptions = country.Regions;
    }
}
CountryAndRegionsComponent.ɵfac = function CountryAndRegionsComponent_Factory(t) { return new (t || CountryAndRegionsComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc1.LoggingService), ɵngcc0.ɵɵdirectiveInject(ɵngcc1.CountryService), ɵngcc0.ɵɵdirectiveInject(ɵngcc1.CountryQuery)); };
CountryAndRegionsComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: CountryAndRegionsComponent, selectors: [["fgbcl-country-and-regions"]], inputs: { HasSubmitted: "HasSubmitted", SeparateRow: "SeparateRow", Form: "Form" }, decls: 22, vars: 29, consts: [[3, "formGroup"], [1, "row", "country-and-regions"], [3, "ngClass"], ["for", "Country", 1, "mb-2"], ["id", "Country", "name", "Country", "formControlName", "Country", "required", "", 1, "form-control", 3, "ngClass", "change"], ["value", "", "selected", "", "disabled", "", "hidden", ""], [3, "value", 4, "ngFor", "ngForOf"], [1, "invalid-feedback"], ["for", "County", 1, "mb-2"], ["id", "County", "class", "form-control", "name", "County", "type", "text", "formControlName", "County", "required", "", 3, "ngClass", 4, "ngIf"], ["class", "invalid-feedback", 4, "ngIf"], [3, "value"], ["id", "County", "name", "County", "type", "text", "formControlName", "County", "required", "", 1, "form-control", 3, "ngClass"]], template: function CountryAndRegionsComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelementStart(2, "div", 2);
        ɵngcc0.ɵɵelementStart(3, "label", 3);
        ɵngcc0.ɵɵtext(4);
        ɵngcc0.ɵɵpipe(5, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(6, "select", 4);
        ɵngcc0.ɵɵlistener("change", function CountryAndRegionsComponent_Template_select_change_6_listener($event) { return ctx.getRegionsByCountry($event.target.value); });
        ɵngcc0.ɵɵelementStart(7, "option", 5);
        ɵngcc0.ɵɵtext(8);
        ɵngcc0.ɵɵpipe(9, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(10, CountryAndRegionsComponent_option_10_Template, 2, 2, "option", 6);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(11, "div", 7);
        ɵngcc0.ɵɵtext(12);
        ɵngcc0.ɵɵpipe(13, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(14, "div", 2);
        ɵngcc0.ɵɵelementStart(15, "label", 8);
        ɵngcc0.ɵɵtext(16);
        ɵngcc0.ɵɵpipe(17, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(18, CountryAndRegionsComponent_select_18_Template, 5, 7, "select", 9);
        ɵngcc0.ɵɵtemplate(19, CountryAndRegionsComponent_input_19_Template, 1, 3, "input", 9);
        ɵngcc0.ɵɵtemplate(20, CountryAndRegionsComponent_div_20_Template, 3, 3, "div", 10);
        ɵngcc0.ɵɵtemplate(21, CountryAndRegionsComponent_div_21_Template, 3, 3, "div", 10);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("formGroup", ctx.Form);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction2(21, _c1, !ctx.SeparateRow, ctx.SeparateRow));
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(5, 13, "address.country.label"));
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(24, _c0, ctx.HasSubmitted && !!ctx.Form.controls.Country.errors));
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(9, 15, "country.options.default.select"));
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.countryOptions);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(13, 17, "address.missing.country"));
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction2(26, _c2, !ctx.SeparateRow, ctx.SeparateRow));
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(17, 19, "address.region.label"));
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.regionOptions.length > 1);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.regionOptions[0] == null);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.regionOptions.length > 1);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.regionOptions[0] == null);
    } }, directives: [ɵngcc2.NgControlStatusGroup, ɵngcc2.FormGroupDirective, ɵngcc3.NgClass, ɵngcc2.SelectControlValueAccessor, ɵngcc2.NgControlStatus, ɵngcc2.FormControlName, ɵngcc2.RequiredValidator, ɵngcc2.NgSelectOption, ɵngcc2.ɵangular_packages_forms_forms_z, ɵngcc3.NgForOf, ɵngcc3.NgIf, ɵngcc2.DefaultValueAccessor], pipes: [ɵngcc4.TranslatePipe], styles: [".invalid-feedback[_ngcontent-%COMP%]{font-size:.625rem}.country-and-regions[_ngcontent-%COMP%]{margin-bottom:1rem}"] });
CountryAndRegionsComponent.ctorParameters = () => [
    { type: LoggingService },
    { type: CountryService },
    { type: CountryQuery }
];
CountryAndRegionsComponent.propDecorators = {
    Form: [{ type: Input }],
    HasSubmitted: [{ type: Input }],
    SeparateRow: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CountryAndRegionsComponent, [{
        type: Component,
        args: [{
                selector: 'fgbcl-country-and-regions',
                template: "<div [formGroup]=\"Form\">\r\n  <div class=\"row country-and-regions\">\r\n    <div [ngClass]=\"{ 'form-group col-lg-6 mb-3 mb-lg-0': !SeparateRow, 'form-group col-lg-12': SeparateRow }\">\r\n      <label class=\"mb-2\" for=\"Country\">{{ 'address.country.label' | translate }}</label>\r\n      <select\r\n        (change)=\"this.getRegionsByCountry($event.target.value)\"\r\n        id=\"Country\"\r\n        class=\"form-control\"\r\n        name=\"Country\"\r\n        formControlName=\"Country\"\r\n        [ngClass]=\"{ 'is-invalid': HasSubmitted && !!Form.controls.Country.errors }\"\r\n        required\r\n      >\r\n        <option value=\"\" selected disabled hidden>{{ 'country.options.default.select' | translate }}</option>\r\n        <option *ngFor=\"let country of countryOptions\" [value]=\"country.CountryName\">\r\n          {{ country.DisplayName }}\r\n        </option>\r\n      </select>\r\n      <div class=\"invalid-feedback\">{{ 'address.missing.country' | translate }}</div>\r\n    </div>\r\n    <div [ngClass]=\"{ 'form-group col-lg-6': !SeparateRow, 'form-group col-lg-12': SeparateRow }\">\r\n      <label class=\"mb-2\" for=\"County\">{{ 'address.region.label' | translate }}</label>\r\n      <select\r\n        *ngIf=\"regionOptions.length > 1\"\r\n        id=\"County\"\r\n        class=\"form-control\"\r\n        name=\"County\"\r\n        type=\"text\"\r\n        formControlName=\"County\"\r\n        [ngClass]=\"{ 'is-invalid': HasSubmitted && !!Form.controls.County.errors }\"\r\n        required\r\n      >\r\n        <option value=\"\" selected disabled hidden>{{ 'region.options.default.select' | translate }}</option>\r\n        <option *ngFor=\"let region of regionOptions\" value=\"{{ region.RegionName }}\">\r\n          {{ region.DisplayName }}\r\n        </option>\r\n      </select>\r\n\r\n      <input\r\n        *ngIf=\"regionOptions[0] == null\"\r\n        id=\"County\"\r\n        class=\"form-control\"\r\n        name=\"County\"\r\n        type=\"text\"\r\n        formControlName=\"County\"\r\n        [ngClass]=\"{ 'is-invalid': HasSubmitted && !!Form.controls.County.errors }\"\r\n        required\r\n      />\r\n      <div *ngIf=\"regionOptions.length > 1\" class=\"invalid-feedback\">{{ 'address.missing.region.select' | translate }}</div>\r\n      <div *ngIf=\"regionOptions[0] == null\" class=\"invalid-feedback\">{{ 'address.missing.region.entry' | translate }}</div>\r\n    </div>\r\n  </div>\r\n</div>\r\n",
                styles: [".invalid-feedback{font-size:.625rem}.country-and-regions{margin-bottom:1rem}"]
            }]
    }], function () { return [{ type: ɵngcc1.LoggingService }, { type: ɵngcc1.CountryService }, { type: ɵngcc1.CountryQuery }]; }, { HasSubmitted: [{
            type: Input
        }], SeparateRow: [{
            type: Input
        }], Form: [{
            type: Input
        }] }); })();

class CountryAndRegionsModule {
}
CountryAndRegionsModule.ɵfac = function CountryAndRegionsModule_Factory(t) { return new (t || CountryAndRegionsModule)(); };
CountryAndRegionsModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: CountryAndRegionsModule });
CountryAndRegionsModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ imports: [[
            CommonModule,
            FormsModule,
            ReactiveFormsModule,
            NgbModule,
            TranslateModule.forRoot({
                loader: {
                    provide: TranslateLoader,
                    useClass: FGBTranslationLoader,
                    deps: [HttpClient]
                },
                missingTranslationHandler: {
                    provide: MissingTranslationHandler,
                    useClass: FGBMissingTranslationHandler
                }
            }),
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(CountryAndRegionsModule, { declarations: function () { return [CountryAndRegionsComponent]; }, imports: function () { return [CommonModule,
        FormsModule,
        ReactiveFormsModule,
        NgbModule, ɵngcc4.TranslateModule]; }, exports: function () { return [CountryAndRegionsComponent]; } }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CountryAndRegionsModule, [{
        type: NgModule,
        args: [{
                declarations: [CountryAndRegionsComponent],
                imports: [
                    CommonModule,
                    FormsModule,
                    ReactiveFormsModule,
                    NgbModule,
                    TranslateModule.forRoot({
                        loader: {
                            provide: TranslateLoader,
                            useClass: FGBTranslationLoader,
                            deps: [HttpClient]
                        },
                        missingTranslationHandler: {
                            provide: MissingTranslationHandler,
                            useClass: FGBMissingTranslationHandler
                        }
                    }),
                ],
                exports: [CountryAndRegionsComponent]
            }]
    }], null, null); })();

/**
 * Generated bundle index. Do not edit.
 */

export { CountryAndRegionsComponent, CountryAndRegionsModule };

//# sourceMappingURL=fgb-portal-component-library-src-lib-shared-country-and-regions.js.map